import { createSlice, current } from '@reduxjs/toolkit';
import {
	getRolesList,
	getRole,
	addNewRole,
	updateRole,
	deleteRole,
	getUserByRoles,
	getMenuScopesRole
} from '../roles/thunk';

export const initialState = {
	itemRoleList: [],
	itemRoleDetail: null,
	isRoleLoading: false,
	isRoleSuccess: false,
	menuScopes: [],
	isLoadingMenuScopes: false,

	roleList: [],
	itemUserRoleList: [],
	roleListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const RoleSlice = createSlice({
	name: 'Roles',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		setItemRoleDetail(state, action) {
			state.itemRoleDetail = action.payload;
		}
	},
	extraReducers: builder => {
		builder.addCase(getRole.fulfilled, (state, action) => {
			state.isRoleLoading = false;
			state.isRoleSuccess = true;
			state.itemRoleDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getRole.pending, state => {
			state.isRoleLoading = true;
			state.isRoleSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getRole.rejected, (state, action) => {
			state.isRoleLoading = false;
			state.isRoleSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(getRolesList.pending, state => {
			state.isRoleSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getRolesList.fulfilled, (state, action) => {
			state.itemRoleList = action.payload;
			state.roleList = action.payload;
			state.isLoadingList = false;
			state.isRoleSuccess = true;

			let roleListSelect = [];
			action.payload.map(item =>
				roleListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.roleListSelect = roleListSelect;
		});
		builder.addCase(getRolesList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isRoleSuccess = true;
		});
		builder.addCase(addNewRole.fulfilled, (state, action) => {
			state.itemRoleList.push(action.payload);
			state.roleList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewRole.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewRole.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateRole.fulfilled, (state, action) => {
			state.itemRoleList = state.itemRoleList.map(role =>
				role._id === action.payload._id
					? { ...role, ...action.payload }
					: role
			);
			state.roleList = state.roleList.map(role =>
				role._id === action.payload._id
					? { ...role, ...action.payload }
					: role
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateRole.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateRole.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteRole.fulfilled, (state, action) => {
			state.itemRoleList = current(state.itemRoleList).filter(
				role => role._id !== action.payload._id
			);
			state.roleList = current(state.roleList).filter(
				role => role._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteRole.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteRole.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});



		
		builder.addCase(getUserByRoles.pending, state => {
			state.isRoleSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getUserByRoles.fulfilled, (state, action) => {
			state.itemUserRoleList = action.payload;
			state.roleList = action.payload;
			state.isLoadingList = false;
			state.isRoleSuccess = true;  
		});
		builder.addCase(getUserByRoles.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isRoleSuccess = true;
		});

		builder.addCase(getMenuScopesRole.fulfilled, (state, action) => {
			state.menuScopes = action.payload?.menu_scopes || [];
			state.isLoadingMenuScopes = true;
		});
		builder.addCase(getMenuScopesRole.pending, state => {
			state.menuScopes = [];
			state.isLoadingMenuScopes = true;
		});
		builder.addCase(getMenuScopesRole.rejected, (state, action) => {
			state.menuScopes = [];
			state.isLoadingMenuScopes = false;
		});
	},
});

export const {
	setRequireCloseModal,
	setItemRoleDetail
} = RoleSlice.actions;

export default RoleSlice.reducer;
